import clsx from 'clsx';

import type { ButtonVariant } from './types';

export function resolveVariantClasses(variant: ButtonVariant) {
  switch (variant) {
    case 'outline':
      return clsx('bg-white', 'text-neutral-80', 'border-neutral-80');

    case 'ghost':
      return clsx('bg-neutral-0', 'text-neutral-80', 'border-neutral-80');

    case 'ghost-dark':
      return clsx('bg-transparent', 'text-neutral-0', 'border-neutral-0');

    case 'ghost-muted':
      return clsx('bg-neutral-40', 'text-neutral-80', 'border-neutral-40');

    case 'link':
      return clsx('bg-neutral-0', 'text-neutral-80');

    case 'rounded':
      return clsx('bg-neutral-0', 'text-neutral-80', 'rounded-full');

    case 'add-to-cart':
      return clsx(
        'justify-center',
        'text-center',
        'bg-neutral-80',
        'text-neutral-0'
      );
  }

  // primary
  return clsx('bg-neutral-80', 'text-neutral-0');
}
